<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div><el-divider >修改考试信息</el-divider></div>
        <div style="padding: 10px;">
          <el-form ref="editForm" :model="editForm" label-width="80px" size="mini">
<!--            <el-form-item label="科目名称">
              <el-select v-model="editForm.course" placeholder="请选择">
                <el-option v-for="item in courses" :key="item.course_name" :label="item.course_name" :value="item.course_name">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="考试名称">
              <el-input v-model="editForm.exam" placeholder="如:期中考试"></el-input>
            </el-form-item>
            <el-form-item label="年级班级">
              <el-input v-model="editForm.grade" placeholder="如:三年级6班"></el-input>
            </el-form-item>

<!--            <el-form-item label="卷面分" >
              <el-input v-model="editForm.paper_score" placeholder="正整数,如:150" oninput ="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item> -->
            <el-form-item size="large">
              <el-button type="primary" @click="saveExam()">保存</el-button>
              <el-button @click="back">返回</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import MenuList from './menu.vue'
import Header from './head.vue'

export default {
  components: {
    MenuList,
    Header
  },
  created () {
    this.examID = this.$route.params.id
    // console.log('传递过来的参数是:' + this.examID)
    this.loadCourses()
    this.loadData()
  },
  data () {
    return {
      examID: '',
      selectedCourse: '',
      courses: [],
      editForm: {
        id: '',
        exam: '',
        course: '',
        grade: '',
        paper_score: ''
      }
    }
  },
  methods: {
    loadData () {
      // console.log('加载数据/score/web/_load_exam.jsp')
      let that = this
      var requestUrl = '/score/web/_load_exam.jsp'
      this.axios.get(requestUrl, {
        params: {
          exam_id: that.examID
        }
      }).then(function (response) {
        that.editForm.id = response.data.id
        that.editForm.exam = response.data.exam
        that.editForm.course = response.data.course
        that.editForm.grade = response.data.grade
        that.editForm.paper_score = response.data.paper_score
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    saveExam () {
      let that = this

      // 数据校验
      // if (this.editForm.course === '') {
      //    this.$message.error('请选择科目')
      //    return
      // }
      if (this.editForm.exam === '') {
         this.$message.error('请输入考试名称，如：期中考试')
         return
      }

      if (this.editForm.grade === '') {
         this.$message.error('请输入年级和班级')
         return
      }

      // if (this.editForm.paper_score === '') {
      //    this.$message.error('请输入卷面分')
      //    return
      // }

      var requestUrl = '/score/web/_exam_edit_info_save.jsp'

      this.axios.get(requestUrl, {
        params: {
          exam_id: that.examID,
          exam: that.editForm.exam,
          grade: that.editForm.grade,
          course: that.editForm.course,
          paperScore: that.editForm.paper_score
        }
      }).then(function (response) {
        that.$message.success('保存成功！')
        that.$router.push('/exam_list')
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    back () {
      this.$router.go(-1)
    },
    loadCourses () {
      let that = this
      var requestUrl = '/score/web/_get_courses.jsp'

      this.axios.get(requestUrl, {
        params: {

        }
      }).then(function (response) {
        that.courses = response.data
      })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/exam_edit.vue